<div
    class="bg-rfk-dark-blue absolute top-0 left-0 bg-gradient-to-b from-rfk-dark-blue via-rfk-blue to-rfk-blue bottom-0 leading-5 h-full w-full overflow-hidden">
</div>

<router-outlet></router-outlet>